export default class BaseControl {
    constructor(map, google) {
        this.map = (map || null);
        this.google = (google || null);
        this.controlBox = null;
        this.controlName = null;
    };

    setMap(map, google) {
        this.map = map;
        this.google = google;
    }

    isOpen() {
        return this.controlBox && this.controlName && this.controlBox.getControl(this.controlName) ? true : false;
    }
}